import ReactDOM from 'react-dom';
import { Button } from 'carbon-components-react';
import React, { useEffect, useState, useRef } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import ReferralWarning from './ReferralWarning';
import { APP } from 'app/AppRoutes';
import { selectActiveChannel } from 'redux/channels/selector';
import { RootState } from 'redux/root.reducer';
import { ActiveChannelDataType, CFCProps } from 'types';
import Utils from 'utilities/helper.util';
import ChannelsNoData from '../channelsNoData';
import { currentUser } from 'redux/session/selectors';
import {
  activateReferralChannelsStart,
  fetchActiveChannelByIdStart
} from 'redux/channels';
import EmailActiveChannelComponent from './email.component';
import FallbackActiveChannelComponent from './fallback.component';
import WebHookActiveChannelComponent from './webHook.component';
import SWXAutomateActiveChannelComponent from './SWXAutomate.component';
import { CHANNELS } from 'types';
import PauseResumeReferralChannels from './PauseResumeReferralChannels';
const ActiveChannel: React.FC<Props | any> = ({ clickSandboxHandler }: any) => {
  const dispatch = useDispatch();
  const [isWarningModal, setIsWarningModal] = useState(false);
  // Get user
  const activeChannels: ActiveChannelDataType = useSelector(
    selectActiveChannel
  );
  const userOrgIdRef = useRef<number>();
  const user: any = useSelector(currentUser);

  useEffect(() => {
    userOrgIdRef.current = user?.organisationId;
  }, [user]);

  useEffect(() => {
    dispatch(
      fetchActiveChannelByIdStart({
        organisationId: userOrgIdRef.current,
        channelId: activeChannels?.id
      })
    );
  }, [activeChannels, dispatch]);

  const handleRenew = () =>
    dispatch(
      fetchActiveChannelByIdStart({
        organisationId: user?.organisationId,
        channelId: activeChannels?.id
      })
    );
  const handleToggle = () => {
    setIsWarningModal(false);
    dispatch(
      activateReferralChannelsStart({
        organisationId: user?.organisationId,
        channelId: activeChannels?.id,
        requestBody: {
          isSendingPaused: !activeChannels?.isSendingPaused
        }
      })
    );
  };
  const handleToggleLocal = () => {
    if (activeChannels.isSendingPaused) {
      dispatch(
        activateReferralChannelsStart({
          organisationId: user?.organisationId,
          channelId: activeChannels?.id,
          requestBody: {
            isSendingPaused: !activeChannels?.isSendingPaused
          }
        })
      );
    } else {
      setIsWarningModal(true);
    }
  };

  return (
    <>
      {isWarningModal &&
        ReactDOM.createPortal(
          <ReferralWarning
            handleToggle={handleToggle}
            setIsWarningModal={setIsWarningModal}
          />,
          document.querySelector(`#${APP}`) || document.body
        )}
      <>
        {activeChannels && Utils.isObjectEmpty(activeChannels) ? (
          <ChannelsNoData onClickSandboxHandler={clickSandboxHandler} />
        ) : (
          <div className="referral-active--wrapper">
            <div className="referral-active-form-parent">
              <div className="referral-active-form">
                {activeChannels?.configurationType === CHANNELS.LEGACY && (
                  <EmailActiveChannelComponent />
                )}
                {activeChannels?.configurationType === CHANNELS.FALLBACK && (
                  <FallbackActiveChannelComponent />
                )}
                {activeChannels?.configurationType === CHANNELS.WEBHOOK && (
                  <WebHookActiveChannelComponent />
                )}
                {activeChannels?.configurationType ===
                  CHANNELS.SWX_AUTOMATE && (
                  <SWXAutomateActiveChannelComponent />
                )}
                <Button kind="ghost" size="small" onClick={clickSandboxHandler}>
                  Channels sandbox
                </Button>
              </div>
            </div>
            <PauseResumeReferralChannels
              isSendingPaused={activeChannels?.isSendingPaused}
              handleToggleLocal={handleToggleLocal}
              handleRenew={handleRenew}
            />
          </div>
        )}
      </>
    </>
  );
};

const mapStateToProps = ({ referralChannels }: RootState) => ({
  referralChannels
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector>;

ActiveChannel.displayName = 'ActiveChannel';

export default connector(ActiveChannel);
